
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBeaconGeneralTShape as ObiBeaconGeneralTShapeElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-beacon-general-t-shape.js';
 
 
 

 
 export const ObiBeaconGeneralTShape = createComponent({
   react: React,
   tagName: 'obi-beacon-general-t-shape',
   elementClass: ObiBeaconGeneralTShapeElement,
   events: {
     
   }
  });
 
 